import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  contactTitle: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '140%',
    color: theme.palette.primary.main,
    paddingBottom: '8px',
  },
  paper: {
    borderRadius: '8px',
    border: `3px solid ${theme.palette.primary.main}`,
  },
  dialogSubtitle: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '16px',
  },
  dialogDescription: {
    fontWeight: 300,
    fontSize: '12px',
    paddingTop: '8px',
  },
}));

export default useStyles;
